import type { Tag } from "@/services/api/tags";
import {
  sortBy,
  comparators,
  type SortDirection,
} from "@/shared/lib/sortUtils";

export type TagSortField = "name" | "filesCount" | "isActive";
export type TagSortDirection = SortDirection;

interface TagWithCount extends Tag {
  filesCount?: number;
}

export function sortTags(
  tags: Tag[],
  sortField: TagSortField,
  sortDirection: TagSortDirection
): Tag[] {
  const regularTags: TagWithCount[] = [];
  const aiGeneratedTags: TagWithCount[] = [];

  tags.forEach((tag) => {
    if (tag.type === "AiGenerated") {
      aiGeneratedTags.push(tag as TagWithCount);
    } else {
      regularTags.push(tag as TagWithCount);
    }
  });

  const sortedRegularTags = sortBy(regularTags, sortField, sortDirection, {
    name: comparators.string((tag) => tag.name ?? null),
    filesCount: comparators.number(
      (tag) => (tag as TagWithCount).filesCount ?? tag.fileCount ?? 0
    ),
    isActive: comparators.boolean((tag) => tag.isActive),
  });

  const sortedAiGeneratedTags = sortBy(
    aiGeneratedTags,
    sortField,
    sortDirection,
    {
      name: comparators.string((tag) => tag.name ?? null),
      filesCount: comparators.number(
        (tag) => (tag as TagWithCount).filesCount ?? tag.fileCount ?? 0
      ),
      isActive: comparators.boolean((tag) => tag.isActive),
    }
  );

  return [...sortedRegularTags, ...sortedAiGeneratedTags];
}
